
import {Component, Vue, Watch} from 'vue-property-decorator';
  import AppDialog from '@/modules/Popup/components/AppDialog.vue';
  import {IAppMediaPopup} from "@/shared/AppMediaPopup/interfaces/app-media-popup.interface";
  import {bus} from "@/plugins/bus";
  import AppMediaPopupInfo from "@/shared/AppMediaPopup/components/AppMediaPopupInfo.vue";
import AppMediaPopupPhotoInfo from "@/shared/AppMediaPopup/components/AppMediaPopupPhotoInfo.vue";

  @Component({
    components: {
      AppMediaPopupPhotoInfo,
      AppMediaPopupInfo,
      AppDialog,
    },
  })
  export default class AppMediaPopup extends Vue {
    $refs: any;
    currentPopup = { blockName: 'allPages', dialogName: 'appMediaPopup' };
    imageLoading = false;
    imageError = false;
    currentIndex = 0;
    lastDirection = null;

    get payloadPopup(): IAppMediaPopup.IPayload { return this.$store.getters['dialog/getPopupPayload'](this.currentPopup); }
    get isLast() { return this.currentIndex === this.max - 1; }
    get isFirst() { return this.currentIndex === 0; }
    get max() { return this.payloadPopup.files.length; }

    get isLastParentList() { return this.payloadPopup.parentList && this.payloadPopup.parentList.currentIndex + 1 === this.payloadPopup.parentList.total; }
    get isFirstParentList() { return this.payloadPopup.parentList && this.payloadPopup.parentList.currentIndex === 0; }

    get needUpdatePopup() { return this.$store.state.dialog.updatePopup; }

    mounted() {
      window.addEventListener('keydown', (e) => this.onKeyDown(e));
    }

    onKeyDown(e: KeyboardEvent) {
      const arrowLeft = 37;
      const arrowRight = 39;

      if (e.keyCode === arrowLeft && !this.isFirst) {
        this.toggleIndex(this.currentIndex - 1);
      }
      else if (e.keyCode === arrowRight && !this.isLast) {
        this.toggleIndex(this.currentIndex + 1);
      }
    }

    touchStart(touchEvent) {
      if (touchEvent.changedTouches.length !== 1) { // We only care if one finger is used
        return;
      }
      const posXStart = touchEvent.changedTouches[0].clientX;
      addEventListener('touchend', (touchEvent) => this.touchEnd(touchEvent, posXStart), {once: true});
    }

    touchEnd(touchEvent, posXStart) {
      if (touchEvent.changedTouches.length !== 1) { // We only care if one finger is used
        return;
      }
      const posXEnd = touchEvent.changedTouches[0].clientX;
      if (posXStart < posXEnd) {
        this.swipeLeft(); // swipe right
      } else if (posXStart > posXEnd) {
        this.swipeRight(); // swipe left
      }
    }

    swipeLeft() {
      if (this.currentIndex > 0) {
        this.toggleIndex(this.currentIndex - 1);
      }
    }

    swipeRight() {
      if (this.currentIndex < this.max - 1) {
        this.toggleIndex(this.currentIndex + 1);
      }
    }

    toggleIndex(index: number) {
      this.currentIndex = index;
    }

    toggleToNext(direction: number) {
      if ((direction === +1 && this.isLastParentList) || (direction === -1 && this.isFirstParentList)) return;
      this.lastDirection = direction;
      bus.$emit(
        IAppMediaPopup.EmitterEvents.ToggleEntityTo + this.payloadPopup.parentList.name,
        { indexRow: this.payloadPopup.parentList.currentIndex, direction }
      );
    }

    async onClose() {
      this.$refs.appDialog.onClose();
    }

    @Watch('needUpdatePopup')
    onUpdatePopup() {
      if (!this.needUpdatePopup) {
        this.currentIndex = this.lastDirection && this.lastDirection === +1 ? 0 : this.max - 1;
      }
    }

    destroyed() {
      window.removeEventListener('keydown', (e) => this.onKeyDown(e));
    }
  }
